
import { Component, Watch, Vue } from 'vue-property-decorator'
import ls from '@/ls'
import { ROUTE_TO_MENU } from '@/navigationKeys'
import { canAny } from '@/globalFunctions'

@Component({
  methods: { canAny },
  components: {}
})

export default class Navigation extends Vue {
  selectedKeys:string[] = []
  openSubMenus:string[] = ls.get('openSubMenus') || []

  @Watch('$route.name')
  onRouteChanged () : void {
    this.setActiveRoute()
  }

  mounted () : void {
    this.setActiveRoute()
  }

  setActiveRoute (): void {
    const name = this.$route.name as string | null
    if (!name) return

    const hit = ROUTE_TO_MENU[name]
    if (hit) {
      this.selectedKeys = [hit.key]

      const stored = ls.get('openSubMenus') || []
      const merged = Array.from(new Set([...(hit.openKeys || []), ...stored]))
      this.openSubMenus = merged
      ls.set('openSubMenus', merged)
    } else {
      this.selectedKeys = [name]
    }
  }

  toggleSubMenus (openKeys:string[]) : void {
    this.openSubMenus = openKeys
    ls.set('openSubMenus', openKeys)
  }

  logout () : void {
    this.$store.dispatch('authStore/logout')
  }

  get navigationCollapsed () : boolean {
    return this.$store.getters.navigationCollapsed
  }

  get screenWidth () : number {
    return screen.width
  }

  get environment (): string {
    switch (process.env.VUE_APP_MS_CALLBACK_DOMAIN) {
      case 'admin.woonon.nl': return 'production'
      case 's-admin.woonon.nl': return 'staging'
      default: return 'development'
    }
  }
}
